<template>
    <div>
        <div class="sess_info_cont">
            <div class="column sess_info_mini">
                <div class="close " @click="close_add_sess_admin()">close</div>
                <div class="sess_info sess_info_custom">

                    <div class="right" v-if="!pets || pets === null">
                        <h3 class=" hone_link">Add grooming session</h3>
                        <div class="back_cont">
                            <form class="row btn_home_cont">
                                <input type="tel" placeholder="Phone" class="input" v-model="phone__"
                                    @focus="magic_flag = true" @blur="magic_flag = false">

                                <button
                                    :class="loading ? 'btn btn_first_grooming no_padding' : 'btn btn_first_grooming'"
                                    @click.prevent="from_step_1()">
                                    <div class="loading" v-if="loading">
                                        <Spinner />
                                    </div>
                                    <div class="btn_txt" v-else>Next</div>
                                </button>

                            </form>
                            <div v-if="error" class="err_single_line">{{ error }}</div>
                        </div>
                    </div>

                    <div class="right" v-if="pets && pets !== null && service_stage === false">
                        <h3 class=" hone_link">Add grooming session</h3>
                        <div class="mini_title">Choose A Pet For Grooming</div>
                        <div class="row btn_home_cont">
                            <div class="row pet_cards_cont" v-if="pets && Array.isArray(pets)">
                                <div v-for="(pet, i) in pets" :key="pet.id"
                                :class=" pet.selected === true ? 'column pet_card selected' : 'column pet_card ' "
                                @click="pet_add_handel(i)"
                                >
                                    <img v-if="pet.type === 'dog'" class="label_img" src="@/assets/dog.svg">
                                    <img v-else class="label_img" src="@/assets/cat.svg">
                                    <div class="pet_name">{{pet.name}}</div>
                                </div>
                                <div class="column pet_card" @click="add_pet()">
                                <img class="label_img" src="@/assets/add.svg">
                                <div class="pet_name">Add Pet</div>
                                </div>
                            </div>
                        </div>
                        <div class="error_msg" v-show="error">{{ error }}</div>
                        <div class="row btns_cont">
                        <div></div>
                            <button class="btn btn_first_grooming"  @click="from_step_3_logged()">Next</button>
                        </div>
                    </div>

                    <div class="" v-if="service_stage === true">

                        <div class="mini_title">Pet Grooming Service</div>


                        <div class="row service_pop_up_cont">

                            <div class="left selected_pets_list">
                                <button class="add_pet_2" @click="$router.push('/step-3-logged')">
                                    <div class="btn_txt">Add Pet</div>
                                </button>
                                <div class="not_my_phone" @click="$router.push({ name: 'home' })">go back to phone step?
                                </div>
                                <div class="pets_list" v-if="check_if_any_pet_selected">
                                    <h4>Your Pets</h4>
                                    <!-- <hr> -->
                                    <ul>
                                        <li v-for="pet in selected_pets_2" :key="pet.id"
                                            @click="select_pet(parseInt(pet.id))"
                                            :class="current_id && (parseInt(current_id) === parseInt(pet.id)) ? 'pet_selected' : ''">
                                            <div class="row list_item_div">
                                                <div>{{ pet.name }}</div>
                                                <!-- <img class="row img" src="@/assets/dog_list.svg" alt="dog_list"> -->
                                                <img @click.stop="open_d_prompt(pet.id, pet.name)"
                                                    class="row img delete_icon" src="@/assets/delete-outline.svg"
                                                    alt="dog_list">
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="right">
                                
                                <div class="check_list_cont check_list_cont_m">
                                    <div class="row mr_top_20 checkmark_cont">
                                        <input type="checkbox" v-model="temp_service_holder.shower" id="shower">
                                        <label class="row checkmark" for="shower">Shower</label>
                                    </div>
                                </div>


                                <!-- Medical Shower -->
                                <div class="check_list_cont check_list_cont_m">
                                    <div class="row mr_top_20 checkmark_cont">
                                        <input type="checkbox" v-model="temp_service_holder.medical_shower"
                                            id="medical_shower">
                                        <label class="checkmark" for="medical_shower">Medical Shower</label>
                                    </div>
                                </div>

                                <!-- Chemical Shower -->
                                <div class="check_list_cont check_list_cont_m" v-if="company === 'pets_club' || company === 'pet_yard'">
                                    <div class="row mr_top_20 checkmark_cont">
                                        <input type="checkbox" v-model="temp_service_holder.chemical_shower"
                                            id="chemical_shower">
                                        <label class="checkmark" for="chemical_shower">Chemical Shower</label>
                                    </div>
                                </div>


                                <!-- dry/foam shower -->
                                <div class="check_list_cont check_list_cont_m" v-if="company !== 'pets_club' || company !== 'pet_yard'">
                                    <div class="row mr_top_20 checkmark_cont">
                                        <input type="checkbox" v-model="temp_service_holder.dry_shower" id="dry_shower">
                                        <label class="checkmark" for="dry_shower">dry/foam shower</label>
                                    </div>
                                </div>

                                <!-- dry/foam shower -->
                                <div class="check_list_cont check_list_cont_m" v-if="company === 'pet_yard'">
                                    <div class="row mr_top_20 checkmark_cont">
                                        <input type="checkbox" v-model="temp_service_holder.dry_shower" id="dry_shower">
                                        <label class="checkmark" for="dry_shower">Foam shower</label>
                                    </div>
                                </div>

                                <hr>

                                <!-- Hair Cut -->
                                <div class="check_list_cont check_list_cont_m" v-if="company !== 'pet_yard'">
                                    <div class="row mr_top_20 checkmark_cont">
                                        <input type="checkbox" v-model="temp_service_holder.hair_cut" id="hair_cut">
                                        <label class="row checkmark" for="hair_cut">Hair Cut</label>
                                    </div>
                                </div>

                                <!-- Hair Trimming -->
                                <div class="check_list_cont check_list_cont_m" v-if="company !== 'pet_yard'">
                                    <div class="row mr_top_20 checkmark_cont">
                                        <input type="checkbox" v-model="temp_service_holder.hair_trimming"
                                            id="hair_trimming">
                                        <label class="checkmark" for="hair_trimming">Hair Trimming</label>
                                    </div>
                                </div>

                                <!-- pet yard only -->

                                <!-- Full Grooming -->
                                <div class="check_list_cont check_list_cont_m" v-if="company === 'pet_yard'">
                                    <div class="row mr_top_20 checkmark_cont">
                                        <input type="checkbox" v-model="temp_service_holder.full_grooming"
                                            id="full_grooming">
                                        <label class="checkmark" for="full_grooming">Full Grooming</label>
                                    </div>
                                </div>

                                <!-- Half Grooming -->
                                <div class="check_list_cont check_list_cont_m" v-if="company === 'pet_yard'">
                                    <div class="row mr_top_20 checkmark_cont">
                                        <input type="checkbox" v-model="temp_service_holder.half_grooming"
                                            id="half_grooming">
                                        <label class="checkmark" for="half_grooming">Half Grooming</label>
                                    </div>
                                </div>

                                <!-- Tangle Grooming -->
                                <div class="check_list_cont check_list_cont_m" v-if="company === 'pet_yard'">
                                    <div class="row mr_top_20 checkmark_cont">
                                        <input type="checkbox" v-model="temp_service_holder.tangle_grooming" @change="testo()"
                                            id="tangle_grooming">
                                        <label class="checkmark" for="tangle_grooming">Tangle Grooming</label>
                                    </div>
                                </div>


                                <hr>

                                <!-- Nail Trimming -->
                                <div class="check_list_cont check_list_cont_m">
                                    <div class="row mr_top_20 checkmark_cont">
                                        <input type="checkbox" v-model="temp_service_holder.nail_trimming"
                                            id="nail_trimming">
                                        <label class="checkmark" for="nail_trimming">Nail Trimming</label>
                                    </div>
                                </div>

                                <!-- Anal Gland Expression -->
                                <div class="check_list_cont check_list_cont_m" v-if="check_if_cat_or_dog === 'dog' && company !== 'pet_yard'">
                                    <div class="row mr_top_20 checkmark_cont">
                                        <input type="checkbox" v-model="temp_service_holder.anal_gland" id="anal_gland">
                                        <label class="checkmark" for="anal_gland">Anal Gland Expression</label>
                                    </div>
                                </div>

                                <!-- textarea -->
                                <div class="row textarea_cont">
                                    <textarea class="textarea" v-model="temp_service_holder.other"
                                        placeholder="Other services"></textarea>
                                </div>

                                <div class="row btns_cont">
                                    <div></div>
                                    <button class="btn btn_first_grooming this" @click="from_services_step()">Next</button>
                                </div>
                            </div>


                        </div>


                    </div>



                </div>
            </div>
        </div>
    </div>
</template>

<script>
import request from '../axios_request';
import { mapState, mapActions } from 'vuex';
import Spinner from '@/components/Spinner.vue';

export default {
    name: 'AdminSingleAddSessComp',
    components: {
        Spinner,
    },
    data: function () {
        return {
            phone__: null,
            pets: null,
            parent_id: null,
            temp_service_holder: {
                shower: false,
                medical_shower: false,
                dry_shower: false,
                chemical_shower: false,


                hair_cut: false,
                hair_trimming: false,

                cat_grooming: false,
                dog_grooming: false,

                half_grooming: false,
                tangle_grooming: false,


                nail_trimming: false,
                anal_gland: false,


                other: null,
                selected: false
            },

            current_id: null,
            // current_pet_type: null,


            service_stage: false,
            magic_flag: false,
            error: null,
            parent_data: null,
            loading: false,

        }
    },
    computed: {
        ...mapState([
            'company',
            // 'role',
            // 'logged_in',
            // 'company_logo',
            // 'receipt_number_feature',
            // 'show_add_sess_admin_',
            // 'branch'
            // 'branch_id',
            // 'socket'
        ]),
        check_if_any_pet_selected() {
            var result = false;
            if (this.pets && Array.isArray(this.pets) && this.pets.length > 0) {
                this.pets.forEach(function (pet) {
                    if (pet.selected && pet.selected === true) {
                        result = true;
                    }
                });
            }
            return result;
        },

        selected_pets_2() {
            return this.pets.filter(pet => pet.selected && pet.selected === true)
        },

        // this function check if the current pet is cat or dog
        check_if_cat_or_dog() {
            if (Array.isArray(this.selected_pets_2) && this.selected_pets_2.length > 0) {
            const selectedPet = this.selected_pets_2.find(pet => pet.id === this.current_id);
            return selectedPet ? selectedPet.type.toLowerCase().trim() : null;
            }
            return null;
        }
    },
    methods: {
        ...mapActions([
            'show_add_sess_admin__',
        ]),
        close_add_sess_admin(){
            this.show_add_sess_admin__(false);
        },


        async from_step_1() {
            if (this.loading) return;
            this.error = null;

            if (!this.phone__) {
                this.error = "must enter phone number.";
                return;
            }

            const pattern = /^\d+$/;
            if (!pattern.test(this.phone__)) {
                this.error = "must enter numbers only.";
                return;
            }

            if (this.phone__.length < 7) {
                this.error = "must enter 7 digits or more.";
                return;
            }

            try {
                this.loading = true;
                const response = await request.post('/api/parent/is_new_parent', { phone: this.phone__ });
                this.loading = false;

                if (response.status === 200 && response.data.new === false) {
                    this.parent_data = response.data;
                    this.parent_id = response.data.data.id;

                    const res = await request.post('/api/pet/get_by_parent', { parent_id: this.parent_id });
                    if (res.status === 200 && Array.isArray(res.data)) {
                        this.pets = res.data;
                        res.data.forEach((pet) => {
                            Object.assign(pet, this.temp_service_holder);
                        });
                    }
                } else {
                    this.parent_data = response.data;
                }

                console.log('hhhh', this.pets, this.parent_data);
            } catch (e) {
                console.error(e);
                this.error = "error.";
                this.loading = false;
            }
        },

      pet_add_handel(i){
        // console.log(i, this.pets[i]);
        if( this.pets[i] ){
          if( this.pets[i].selected && this.pets[i].selected === true ){
            this.pets[i].selected = false;
          }else{
            this.pets[i].selected = true;
            this.error = null;
          }
        }
      },

      select_pet(id){
        this.current_id = id;
      },


      from_step_3_logged(){
        this.error = null;
        var lets_go = false;

        if( this.pets && Array.isArray(this.pets) && this.pets.length > 0 ){
            var current_id_temp = null;
          this.pets.forEach(function (pet) {
            if( pet.selected && pet.selected === true ){
                if( !current_id_temp ){
                  current_id_temp = pet.id;
                }
              lets_go = true;
              return;
            }
          });
          if( lets_go === true ){
            this.service_stage = true;
            this.current_id = current_id_temp;
          }else{
            this.error = 'must select pet for grooming.';
          }
        }else{
          this.error = 'must add and select pet for grooming.';
        }
      },

      from_services_step(){
        console.log('from_services_step');
        console.log(this.pets);
        console.log(this.selected_pets_2);
      },



    }
}
</script>


<style scoped>
.sess_info_cont{
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #00000052;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.sess_info_mini{
    width: 90%;
    max-width: 500px;
    margin-top: 5%;
}

.close{
    text-align: end;
    color: red;
    font-weight: bold;
    width: fit-content;
    align-self: end;
    cursor: pointer;
}

.sess_info{
    margin-top: 5%;
    background-color: white;
    width: 90%;
    max-width: 500px;
    padding: 10px;
    border-radius: 3px;
    overflow-y: auto;
    max-height: 85%;
}

.sess_info_custom{
    margin-top: 0px;
    width: 100%;
}

.pet_cards_cont{
    margin: 15px 0px 30px 0px;
    display: grid;
    grid-gap: 15px;
    grid-template-columns: 100px 100px 100px 100px;
    /* grid-template-rows: 120px 120px 120px 120px; */
    /* column-gap: 10px;
    row-gap: 15px; */
}

.pet_card{
    border: 4px solid #5D8CED;
    border-color: #365889;
    border-radius: 3px;
    height: 100px;
    width: 100px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.pet_card img{
    height: 45px;
    width: auto;
}

.pet_name{
    font-weight: 600;
    color: #365889;
    font-size: 20px;
    margin-top: 5px;
}

.mini_title{
    font-size: 20px;
    font-weight: 500;
}

.selected{
    background-color: #36588942;
}

.pet_selected{
  background-color: #317beb3d;
  padding: 0px 10px;
}

.list_item_div{
  justify-content: space-between;
}

.list_item_div img {
    height: 25px;
}

.selected_pets_list{
    max-width: 30%;
}

.pets_list ul li {
    /* border-bottom: 1px solid; */
    border-bottom: 1px solid #c7c7c7;
    padding-bottom: 16px;
    padding-top: 16px;
    cursor: pointer;
}

input{
    display: block;
    width: 100%;
    padding: 5px 10px;
    /* background-color: #d2dbf3; */
    background-color: #fff;
    /* border: 1px solid #647193; */
    border: 2px solid #ccc;
    /* border-right: 0px; */
    border-radius: 5px;
    font-size: 18px;
    /* -webkit-transition: 0.3s; */
    transition: 0.1s;
    outline: none;
    min-height: 40px;
    font-family: inherit;
    /* resize: vertical; */
    /* margin-bottom: 20px; */
    background-color: #cccccc08;
}

input:focus{
    border: 2px solid #317BEB;
    background-color: white;
}

button{
    padding: 5px 15px !important;
    font-size: 18px;
}

input[type="checkbox"] {
  width: auto;
  margin-right: 7px;
}

.checkmark_cont{
    align-items: center;
}


.pet_selected{
    background-color: #317beb3d;
}
</style>